import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Accordion } from 'react-accessible-accordion';
import { Link } from 'react-router-dom';

import Section from './Section';
import Navbar from '../shared/Navbar';
import Island from '../shared/Island';
import Title from '../shared/Title';
import Text from '../shared/Text';
import CTAButton from '../shared/CTAButton';
import FAQuestion from './FAQuestion';
import { breakpoints, palette } from '../../constants/styles';
import Footer from './Footer';
import ToolsSubset from '../shared/ToolsSubset';
import { mp, getCampaign } from '../../constants/utils';
import ScrollToTopOnMount from '../shared/ScrollToTopOnMount';

const StyledResultImage = styled.img`
  align-self: flex-end;
  max-width: 220px;
  height: auto;
  align-self: center;
  margin-bottom: 20px;
  ${breakpoints.tabletLandscape} {
    margin-top: 80px;
  }
`;

const StyledTeamImage = styled.img`
  max-width: 100%;
  height: auto;
  align-self: center;
  margin: 10px 0px 30px 0px;

  ${breakpoints.mobileLandscape} {
    max-width: 60%;
  }

  ${breakpoints.tabletLandscape} {
    max-width: 50%;
  }

  ${breakpoints.desktop} {
    max-width: 450px;
  }
`;

const StyledValueProp = styled.div`
  position: relative;
  overflow: hidden;
`;

const StyledValuePropCTA = css`
  // background-color: ${palette.secondaryColor};
  margin-top: 1rem;

  &:hover {
    background-color: ${palette.secondaryColorShy};
  } 
  
  
`;

const StyledSecondaryValuePropCTA = css`
  height: 35px;
  color: ${palette.primaryColor};
  background-color: white;
  box-shadow: none;
  border: 1px solid ${palette.primaryColor};
  font-weight: 500;
  width: 150px;

  &:hover {
    background-color: white;
  }
`;

const questions = [
  {
    question: '¿Qué es Finauta?',
    expanded: true,
    answer: (
      <Fragment>
        <Text type="body1">
          Finauta es una empresa mexicana que tiene como fin ayudarte a lograr tus metas
          financieras. Por medio de herramientas financieras amigables y expertos certificados,
          simplificamos las finanzas personales para que tú puedas lograr tus sueños.{' '}
        </Text>
      </Fragment>
    ),
  },
  // {
  //   question: '¿Cómo funciona?',
  //   answer: <Fragment>
  //     <Text type="body1">Para ayudarte a lograr tus metas financieras creamos herramientas financieras con las que podrás entender mejor tus finanzas y conocer los distintos caminos financieros que puedes tomar (ahorro, liquidación de deuda, planeación del retiro, etc.)</Text>
  //     <Text type="body1">Las herramientas financieras te darán un plan preliminar de acción, pero sabemos que tu situación es única. Es por esto que para empezar a tomar acción sobre el camino financiero que elijas podrás ponerte en contacto con uno de nuestros expertos. </Text>
  //     <Text type="body1">Nuestros expertos entenderán tu situación a fondo y trabajarán contigo en comparar tus opciones para que tomes una decisión informada.</Text>
  //     <Text type="body1">Una vez que hayas seleccionado algún instrumento financiero (fondo de ahorro, fondo de  inversión, plan personal para el retiro, etc.) nuestros expertos te ayudarán paso a paso con los trámites necesarios para que así empieces a lograr tus metas financieras.</Text>
  //   </Fragment>,
  // },
  // {
  //   question: '¿En qué partes de México funciona?',
  //   answer: <Fragment>
  //     <Text type="body1">Nuestros servicios están disponibles en todo México</Text>
  //   </Fragment>,
  // },
  // {
  //   question: '¿Cuánto cuesta?',
  //   answer: <Fragment>
  //     <Text type="body1">Es gratis. Sí, en serio.</Text>
  //   </Fragment>,
  // },
  // {
  //   question: '¿Cómo ganan?',
  //   answer: <Fragment>
  //     <Text type="body1">La institución financiera que tú elijas para llevar a cabo tu plan nos paga una comisión por haberte ayudado a encontrarla.</Text>
  //   </Fragment>,
  // },
];

const StyledFirstSection = styled(Section)`
  height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 540px;

  ${breakpoints.tabletLandscape} {
    justify-content: space-evenly;
    flex-direction: row-reverse;
    min-height: 390px;
  }

  ${breakpoints.desktop} {
    height: 90vh;
  }
`;

const StyledSVGs = css`
  margin-top: 20px;
  ${breakpoints.mobileLandscape} {
    max-width: 530px;
  }
`;

const OtherToolsSection = styled(Section)`
  margin: 50px 0px;
`;

const StyledSobreFinauta = css`
  margin-top: 100px;

  ${breakpoints.mobileLandscape} {
    margin-top: 130px;
  }

  ${breakpoints.tabletLandscape} {
    margin-top: 40px;
  }
`;

const StyledSmallFAQ = styled.div`
  max-width: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Statement = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${breakpoints.tabletLandscape} {
    align-items: flex-start;
    max-width: 45%;
  }
`;

class LandingBase extends Component {
  state = {};

  componentDidMount = () => {
    mp(`[${getCampaign(window.location.href)}] | ${this.props.landingName} | Landing | Entra`);
  };

  render() {
    const { children } = this.props;
    return (
      <Fragment>
        <StyledValueProp>
          <ScrollToTopOnMount />

          <Navbar />
          {children}
        </StyledValueProp>
        <Footer />
      </Fragment>
    );
  }
}

LandingBase.propTypes = {
  sections: PropTypes.array,
  landingName: PropTypes.string,
};

LandingBase.defaultProps = {
  sections: [],
  landingName: 'untitled-landing',
};

export default LandingBase;
